<template>
  <v-dialog
    v-model="dialog"
    width="600"    
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
      
    
    <v-card tile>                      
      <v-form ref="form" v-model="valid" lazy-validation>         
        <v-card-text>
          <v-toolbar flat tile class="flex-grow-0 mb-4">
            <v-toolbar-title class="title">{{ $route.meta.nameDrawer }}</v-toolbar-title>
            <v-spacer></v-spacer>
           <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>          
          <v-alert class="my-4" color="red" v-if="errorMessage">
            {{ errorMessage }}
          </v-alert>
          <v-alert class="my-4" color="orange" v-if="alertAttention">
            {{ alertAttention }}
          </v-alert>

          <div>
            <div>{{ $t("agent") }}: {{ name_agent }}</div>
            <div>Id: {{ $route.params.id }}</div>
          </div>

          <v-divider class="mt-2"></v-divider>

          <v-row>
            <v-col cols="3" style="font-size: 0.7rem!important;" class="pb-0 mb-0 overline">{{ $t("from") }} : (Qtd)</v-col>
            <v-col cols="3" style="font-size: 0.7rem!important;" class="pb-0 mb-0 overline">{{ $t("until") }} : (Qtd)</v-col>
            <v-col cols="3" style="font-size: 0.7rem!important;" class="pb-0 mb-0 overline">{{ $t("commissionPrematch") }}: (%)</v-col>
            <v-col cols="3" style="font-size: 0.7rem!important;" class="pb-0 mb-0 overline">{{ $t("commissionLive") }}: (%)              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="info" v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>{{ $t('dialogCommissionLive') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <div v-show="progress" class="text-center pa-4">
            <v-progress-circular
              absolute
              color="info"
              indeterminate
            ></v-progress-circular>
          </div>

          <!-- ROW 1 -->
          <v-row class="d-flex align-center" v-for="(row, index) in rows" :key="index">
            <v-col cols="3">
              <v-text-field
                v-model="row.of"
                outlined
                dense
                :clearable="!isSmallScreen"
                type="number"
                hide-details
                :error="row.errorOf"
                @blur="validValueOf(index)"
                :disabled="disabled == row.errorOf ? false : true"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="row.until"
                outlined
                dense
                :clearable="!isSmallScreen"
                type="number"
                hide-details
                @blur="validValueUntil(index)"
                :error="row.errorUntil"
                :disabled="disabled == row.errorUntil ? false : true"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="row.comission"
                outlined
                dense
                :clearable="!isSmallScreen"
                type="text"
                maxlength="2"                
                hide-details
                @blur="validValueComission(index)"
                :error="row.errorComission"
                :disabled="disabled == row.errorComission ? false : true"
                @keydown="limitToTwoDigits($event)"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="row.comission_live"
                outlined
                dense
                :clearable="!isSmallScreen"
                type="text"
                maxlength="2"
                hide-details
                @blur="validValueComissionLive(index)"
                :error="row.errorComissionLive"
                :disabled="disabled == row.errorComissionLive ? false : true"
                @keydown="limitToTwoDigits($event)"
              ></v-text-field>
              
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-btn
                class="mr-2 white black--text"
                x-small
                @click="removeRow()">
                {{ $t("removeTrack") }}
              </v-btn>
              <v-btn 
              color="info"
              x-small
              @click="addRow()"
              :disabled="!valid || errorMessage != '' "
              >
                {{ $t("addNewTrack") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn class="mr-1 white black--text" small @click="closeDialog()">
            {{ $t("toCancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            small
            v-on:click.prevent="editComissionsBets"
            type="submit"
            :disabled="!valid">
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    
  </v-dialog>
</template>
<script>
export default {
  name: "administrator-users-agents-comissions-bets",
  data: () => ({
    valid: false,
    loading: false,
    errorMessage: "",
    alertAttention: "",
    disabled: false,
    rows: [],
    name_agent: "",    
  }),
  async mounted() {
    // 1. Setup Comissions
    const response = await this.$request.post("administrator/agents/getAgent", {
      id_user: this.$route.params.id,
    });
    if (response.length == 0) {
      return;
    }
    this.name_agent = response.dados.nome;    
    this.rows = response.comissions.map((item, index) => {
      const row = {
        order: index + 1,
        errorOf: false,
        errorUntil: false,
        errorComission: false,
        errorComissionLive: false,
      };
      Object.assign(row, item);
      return row;
    });
  },
  computed: {
    isSmallScreen() {
    return this.$vuetify.breakpoint.width < 381;
  },    
    dialog() {
      return this.$store.state.showDialog;
    },
    progress() {
      return this.$store.state.feedbackProgress;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    limitToTwoDigits(event) {
    const { value } = event.target;  
    
    if (
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === 'Tab' ||
      event.key === 'Backspace'
    ) {
      return;
    }    
    if (
      event.key.length > 1 || 
      /[^\d]/.test(event.key) 
    ) {
      event.preventDefault();
      return;
    }    
    // Limita o comprimento da entrada a dois dígitos
    if (value.length >= 2 && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      return;
    }                             
  },

    // Validation Of:
    validValueOf(index) {
      // A validação deve ser a partir da linha 0
      if (index < 1) return;
      let valueOf = Number(this.rows[index].of);
      let valueUntilPrevious = Number(this.rows[index - 1].until);
      if (valueUntilPrevious >= valueOf) {
        this.rows[index].errorOf = true;
        this.disabled = true;
        this.errorMessage = this.$t(
              "variableCommissions.errors.fromCantBeEqualOrLessThanUntil");
        return;
      }
      if (valueOf - valueUntilPrevious > 1) {
        this.rows[index].errorOf = true;
        this.disabled = true;
        this.errorMessage = this.$t(
              "variableCommissions.errors.fromSuggestion",
              { value: valueUntilPrevious + 1 }
            );
        return;
      }
      this.disabled = false;
      this.rows[index].errorOf = false;
      this.errorMessage = "";
    },

    // Validation Until:
    validValueUntil(index) {
      let row = this.rows[index];
      let valueOf = Number(row.of);
      let valueUntil = Number(row.until);
      if (valueOf > valueUntil) {        
        this.rows[index].errorUntil = true;
        this.disabled = true;
        this.errorMessage = this.$t("variableCommissions.errors.until");
        return;
      }
      this.disabled = false;
      this.rows[index].errorUntil = false;
      this.errorMessage = "";
    },

    // Validation Comission:
    validValueComission(index) {
      let row = this.rows[index];
      let valueComission = Number(row.comission);

      if (valueComission < 0) {
        this.rows[index].errorComission = true;
        this.disabled = true;
        this.errorMessage = this.$t(
          "variableCommissions.errors.comissionBelow0"
        );
        return;
      } 

      if (!Number.isInteger(valueComission)) {
        this.rows[index].errorComission = true;
        this.disabled = true;
        this.errorMessage = this.$t("variableCommissions.errors.intValue");
        return;
      } 

      if (valueComission >= 100) {
        this.rows[index].errorComission = true;
        this.disabled = true;
        this.errorMessage = this.$t("commissionEqualOrGreaterThan100");
        return;
      }      

      if (valueComission > 20) {
        this.alertAttention = this.$t(
          "variableCommissions.errors.comissionAbove20"
        );
      } else {
        this.alertAttention = "";
      }

      this.disabled = false;
      this.rows[index].errorComission = false;
      this.errorMessage = "";
    },

    // Validation Comission Live:
    validValueComissionLive(index) {
      let row = this.rows[index];      
      let valueComission = Number(row.comission_live);

      if (valueComission < 0) {
        this.rows[index].errorComissionLive = true;
        this.disabled = true;
        this.errorMessage = this.$t(
          "variableCommissions.errors.comissionBelowOnli0"
        );
        return;
      }

      if (!Number.isInteger(valueComission)) {
        this.rows[index].errorComissionLive = true;
        this.disabled = true;
        this.errorMessage = this.$t(
          "variableCommissions.errors.intValueOnli"
        );
        return;
      }
      
      if (valueComission >= 100) {
        this.rows[index].errorComissionLive = true;
        this.disabled = true;
        this.errorMessage = this.$t("commissionEqualOrGreaterThan100Onli");
        return;
      } 

      if (valueComission > 20) {
        this.alertAttention = this.$t(
          "variableCommissions.errors.comissionAbove20onli"
        );
      } else {
        this.alertAttention = "";
      }

      this.disabled = false;
      this.rows[index].errorComissionLive = false;
      this.errorMessage = "";
    },

    // Remove the last commission range
    removeRow() {
      this.rows.pop();
      this.disabled = false;
    },

    // Create a new commission track
    addRow() {
      let nextFrom = 1;
      if (this.rows.length > 0) {
        nextFrom =
          Number(this.rows[this.rows.length - 1].until) + 1;
      }
      const order = this.rows.length;
      const row = {
        order: order + 1,
        errorOf: false,
        errorUntil: false,
        errorComission: false,
        errorComissionLive: false,
        of: nextFrom,
        until: this.rows.length > 0 ? parseInt(this.rows[this.rows.length - 1].until) + 2 : 1,
        comission: 0,
        comission_live: 0,
      };
      this.rows.push(row);
      this.validValueUntil(this.rows.length - 1, true);
    },

    async editComissionsBets() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      try {
        const body = {
          id_user: this.$route.params.id,
        };

        for (let i = 0; i < this.rows.length; i++) {
          var obj = this.rows[i];
          for (const [key, value] of Object.entries(obj)) {
            if (
              key != "errorOf" &&
              key != "errorUntil" &&
              key != "errorComission"&&
              key != "errorComissionLive"
            ) {
              body[`${key}[${i}]`] = value;
            }
          }
        }

        const response = await this.$request.post(
          "/administrator/agents/editComissionsBets",
          body
        );

        if (response.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
